import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

function UxMap() {
    return (
        <StaticImage
            src="../../images/UxMap.jpg"
            alt="UX map on an handheld device"
            placeholder="blurred"
            layout="constrained"
        />
    );
}

export default UxMap;
